export function areRestrictionsDisabledForContentType(contentType: string | undefined) {
	if (contentType === 'embed') {
		return true;
	}
	return false;
}
